<template>
  <v-app>
    <!--INDICA LA PÁGINA EN LA QUE SE ENCUETRA-->
    <v-card class="grlCardInfo">
      <v-breadcrumbs :items="obtRuta" class="grlClase">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item @click="insertarRuta(item.ruta)" :disabled="item.disabled">
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-card>
    <!--IMAGEN Y TITULO DE LA PÁGINA-->
    <v-card>
      <v-img :src="imgTitle" class="grlCardImg">
        <div class="grlCardInfo">
          <h1 class="my-auto hidden-sm-and-down">Marco Jurídico</h1>
        </div>
      </v-img>
    </v-card>
    <!--CONTENEDOR QUE MUESTRA LOS REGLAMENTOS-->
    <div class="gralMargenes" id="gralEspaciado">
      <!--TITULO DE LA TABLA-->
      <span class="title">
        <h2> Reglamentos FAZ</h2>
      </span>
      <v-row>
      <v-col v-for="item in items" :key="item.id" cols="12" md="4">
        <v-card class="mjCardPDFS"  shaped elevation="10" color="#FFFF">
          <v-card-text>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <p class="mjVerTexto">{{ item.name }}</p>
                </span>
              </template>
              <span>{{ item.name }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <p class="mjVerTexto"><b>Dirigido: </b>{{ item.dirigido }}</p>
                </span>
              </template>
              <span>{{ item.dirigido }}</span>
            </v-tooltip>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn icon v-bind:href="`../pdfs/${item.pdf}`" target="_blank">
              <v-icon color="red">mdi-download</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    </div>
  </v-app>
</template>
<script>
import datos from '../../../reglamentos.json';

export default {
  data: () => ({
    imgTitle: require('../../assets/img/banner-marco-juridico.jpg'),
    obtRuta: [
      {
        text: 'Inicio',
        disabled: false,
        ruta: '/',
      },
      {
        text: 'Conócenos',
        disabled: true,
        ruta: 'breadcrumbs_link_1',
      },
      {
        text: 'Marco Jurídico',
        disabled: true,
        ruta: 'breadcrumbs_link_1',
      },
    ],
  }),
  methods: {
    insertarRuta(ruta) {
      this.$router.push(ruta);
    },
  },
  computed: {
    items() {
      return datos;
    },
  },
};
</script>
